import React from 'react'
import { Box, Card, CardContent, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const CollectorStatsCards = ({ selectedZone }) => {
  const getCancellationRate = (zone) => {
    if (zone.quotes_canceled_count + zone.quotes_collected_count !== 0) {
      return (
        (zone.quotes_canceled_count /
          (zone.quotes_canceled_count + zone.quotes_collected_count)) *
        100
      ).toFixed(2)
    }

    return 0
  }

  const cards = [
    { head: 'collector name', body: selectedZone.company_name },
    {
      head: 'Average price per ton',
      body: selectedZone.average_price_per_tone,
    },
    { head: 'Quotes in zone', body: selectedZone.total_quotes_in_zone },
    {
      head: 'Assigned',
      body:
        selectedZone.quotes_collected_count +
        selectedZone.quotes_canceled_count,
    },
    { head: 'Cancelled', body: selectedZone.quotes_canceled_count },
    {
      head: 'Cancellation rate',
      body: getCancellationRate(selectedZone) + '%',
    },
    { head: 'Dominance', body: selectedZone.perc_max_prices },
    { head: 'Postcodes covered', body: selectedZone.postcodes_covered_count },
    { head: 'Collected', body: selectedZone.quotes_collected_count },
  ]

  return (
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Grid container spacing={2}>
        {cards.map((card) => (
          <Grid item xs={12} sm={6} md={4} lg={2.4} key={card.head}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#f5f5f5',
                borderRadius: 2,
                boxShadow: 3,
                '&:hover': { transform: 'scale(1.02)' },
              }}
            >
              <CardContent sx={{ textAlign: 'center', p: 2 }}>
                <Typography variant="h5" color="primary">
                  {card.head}
                </Typography>
                <Typography variant="body1" sx={{ mt: 1 }}>
                  {card.body}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

CollectorStatsCards.propTypes = {
  selectedZone: PropTypes.object,
}

export default CollectorStatsCards
